<template>
  <div>
    <p class="input-label text-style dark--text mb-1 mt-5">Collector</p>
    <v-select
      :value="collectors.length == 1? collectors[0] : collector"
      :items="collectors"
      item-text="name"
      :placeholder="collectors.length == 1 ? '' : 'Choose Collector'"
      :menu-props="{ offsetY: true }"
      class="select-field"
      :disabled="loadingCollectors || collectors.length <= 1"
      :loading="loadingCollectors"
      :rules="[rules.required]"
      return-object
      :clearable="isClearable"
      @change="$emit('update:collector', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'MyNetworkDocuments',
  props: {
    collector: {
      type: Object,
      default: null
    },
    collectors: {
      type: Array,
      default: null
    },
    loadingCollectors: {
      type: Boolean,
      default: false
    },
    isClearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rules: {
        required: v => !!v || 'Field is Required'
      }
    }
  },
  computed: {
    paths () {
      return (this.collectors && this.collectors.find(c => c.entity_id === this.collector)?.drives) || []
    }
  },
  beforeDestroy () {
    this.$emit('update:collector', null)
  }
}
</script>

<style scoped>

</style>
